export default __webpack_public_path__ + "static/media/IMG_0363-2.b336c7ed.jpg";